// MOMERY CUSTOM — FAC cart pricing integration.
(function (root) {
    if (root.FacCartPricing) {
        return;
    }

    const CART_VALIDATION_URL = '/apps/fac-pricing/pricing/cart-validation';
    const FAC_SELECTED_OPTIONS_FORM_PROPERTY = 'properties[_fac_printess_selected_options]';
    const POSTER_PRODUCTION_PROPERTIES = [
        '_printessAdditionalProperties',
        '_fa_variant_id',
        'flyeralarm_variant_id',
        'flyeralarm_product_id',
        'flyeralarm_quantity_id',
        '_pack_quantity',
        '_template_suffix',
        '_is_pack_quantity_context',
        '_fa_is_printess',
    ];
    const CLIENT_MAPPING_PROPERTIES = [
        '_fa_variant_id',
        'flyeralarm_variant_id',
        'flyeralarm_product_id',
        'flyeralarm_quantity_id',
    ];

    function copyPresentProperties(source, propertyNames) {
        return propertyNames.reduce((properties, propertyName) => {
            if (Object.prototype.hasOwnProperty.call(source, propertyName)) {
                properties[propertyName] = source[propertyName];
            }

            return properties;
        }, {});
    }

    function sanitizeAdditionalProperties(rawValue, useServerVariantMapping) {
        if (!useServerVariantMapping) {
            return rawValue;
        }

        if (typeof rawValue !== 'string' || rawValue.length === 0) {
            return null;
        }

        try {
            const decoded = JSON.parse(rawValue);

            if (!decoded || Array.isArray(decoded) || typeof decoded !== 'object') {
                return null;
            }

            CLIENT_MAPPING_PROPERTIES.forEach((propertyName) => {
                delete decoded[propertyName];
            });

            return JSON.stringify(decoded);
        } catch (error) {
            return null;
        }
    }

    function filterProductionProperties(source, useServerVariantMapping) {
        if (!useServerVariantMapping) {
            return copyPresentProperties(source, POSTER_PRODUCTION_PROPERTIES);
        }

        const properties = {
            _fac_use_server_variant_mapping: '1',
        };
        const sanitizedAdditionalProperties = sanitizeAdditionalProperties(
            source._printessAdditionalProperties,
            true
        );

        if (sanitizedAdditionalProperties !== null) {
            properties._printessAdditionalProperties = sanitizedAdditionalProperties;
        }

        return properties;
    }

    function formLineItemProperties(payload) {
        const propertyNames = [
            ...POSTER_PRODUCTION_PROPERTIES,
            '_fac_use_server_variant_mapping',
        ];

        return propertyNames.reduce((properties, propertyName) => {
            const formName = `properties[${propertyName}]`;

            if (Object.prototype.hasOwnProperty.call(payload, formName)) {
                properties[propertyName] = payload[formName];
            }

            return properties;
        }, {});
    }

    function isServerVariantMappingEnabled(properties) {
        return properties._fac_use_server_variant_mapping === '1';
    }

    function normalizeFlyeralarmVariantId(value) {
        if (typeof value === 'string') {
            const normalizedValue = value.trim();

            return normalizedValue.length > 0 ? normalizedValue : null;
        }

        if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
            return String(value);
        }

        return null;
    }

    function normalizePackQuantity(value) {
        if (typeof value === 'number') {
            return Number.isSafeInteger(value) && value > 0 ? String(value) : null;
        }

        if (typeof value === 'string') {
            const normalizedValue = value.trim();

            return /^[1-9]\d*$/.test(normalizedValue) && Number.isSafeInteger(Number(normalizedValue))
                ? normalizedValue
                : null;
        }

        return null;
    }

    function isPositiveDecimalString(value) {
        return typeof value === 'string' && /^[1-9]\d*$/.test(value);
    }

    function normalizePricingAuthorizationResult(result, baseQuantity) {
        if (!result || Array.isArray(result) || typeof result !== 'object') {
            throw new Error('Invalid pricing authorization response.');
        }

        if (!Number.isInteger(baseQuantity) || baseQuantity < 1) {
            throw new Error('Invalid base quantity.');
        }

        const version = result.pricing_authorization_version;

        if (version !== 'v1' && version !== 'v2') {
            throw new Error('Invalid pricing authorization response.');
        }

        if (typeof result.pricing_payload !== 'string' || result.pricing_payload.length === 0) {
            throw new Error('Invalid pricing authorization response.');
        }

        let signedPayload;

        try {
            signedPayload = JSON.parse(result.pricing_payload);
        } catch (error) {
            throw new Error('Invalid pricing authorization response.');
        }

        if (
            !signedPayload ||
            Array.isArray(signedPayload) ||
            typeof signedPayload !== 'object' ||
            signedPayload.version !== version
        ) {
            throw new Error('Invalid pricing authorization response.');
        }

        const totalDeltaCents = result.total_delta_cents;
        const surchargeQuantity = result.surcharge_quantity;
        const surchargeVariantId = result.surcharge_variant_id;
        const printessTemplateId = result.printess_template_id;

        if (
            !Number.isInteger(totalDeltaCents) ||
            totalDeltaCents < 0 ||
            !Number.isInteger(surchargeQuantity) ||
            surchargeQuantity < 0 ||
            typeof result.cart_group_id !== 'string' ||
            result.cart_group_id.length === 0 ||
            typeof result.pricing_signature !== 'string' ||
            result.pricing_signature.length === 0 ||
            !Number.isInteger(result.expires_at) ||
            result.expires_at < 1 ||
            !Number.isInteger(printessTemplateId) ||
            printessTemplateId < 1
        ) {
            throw new Error('Invalid pricing authorization response.');
        }

        if (
            signedPayload.total_delta_cents !== totalDeltaCents ||
            signedPayload.surcharge_variant_id !== surchargeVariantId ||
            signedPayload.surcharge_quantity !== surchargeQuantity ||
            signedPayload.quantity !== baseQuantity ||
            signedPayload.cart_group_id !== result.cart_group_id ||
            signedPayload.expires_at !== result.expires_at ||
            signedPayload.printess_template_id !== printessTemplateId
        ) {
            throw new Error('Invalid pricing authorization response.');
        }

        if (version === 'v1') {
            if (
                !isPositiveDecimalString(surchargeVariantId) ||
                (totalDeltaCents === 0 && surchargeQuantity !== 0) ||
                (totalDeltaCents > 0 && surchargeQuantity < 1)
            ) {
                throw new Error('Invalid pricing authorization response.');
            }
        } else if (
            (totalDeltaCents === 0 && (surchargeVariantId !== null || surchargeQuantity !== 0)) ||
            (totalDeltaCents > 0 && (
                !isPositiveDecimalString(surchargeVariantId) ||
                surchargeQuantity !== baseQuantity
            ))
        ) {
            throw new Error('Invalid pricing authorization response.');
        }

        return {
            ...result,
            pricing_authorization_version: version,
            total_delta_cents: totalDeltaCents,
            surcharge_variant_id: surchargeVariantId,
            surcharge_quantity: surchargeQuantity,
        };
    }

    function syncFlyeralarmVariantProperty(form) {
        const propertyName = 'properties[_fa_variant_id]';
        const propertyInputs = Array.from(form.querySelectorAll(`[name="${propertyName}"]`));
        const serverMappingInput = form.querySelector(
            '[name="properties[_fac_use_server_variant_mapping]"]'
        );

        if (serverMappingInput?.value === '1') {
            propertyInputs.forEach((input) => input.remove());

            return null;
        }

        const productForm = form.closest('product-form');

        if (productForm?.dataset.facClientVariantMapping !== 'true') {
            return null;
        }

        let variantMap = {};

        try {
            variantMap = JSON.parse(productForm.dataset.facFlyeralarmVariantMap || '{}');
        } catch (error) {
            console.error('[FAC_CART_PRICING] Invalid Flyeralarm variant map JSON', error);
        }

        const selectedVariantId = String(form.querySelector('[name="id"]')?.value || '');
        const flyeralarmVariantId = normalizeFlyeralarmVariantId(variantMap[selectedVariantId]);

        if (flyeralarmVariantId === null) {
            propertyInputs.forEach((input) => input.remove());

            return null;
        }

        const propertyInput = propertyInputs.shift() || form.ownerDocument.createElement('input');
        propertyInputs.forEach((input) => input.remove());
        propertyInput.type = 'hidden';
        propertyInput.name = propertyName;
        propertyInput.value = flyeralarmVariantId;

        if (!propertyInput.parentNode) {
            form.appendChild(propertyInput);
        }

        return flyeralarmVariantId;
    }

    function syncPackQuantityProperty(form) {
        const propertyName = 'properties[_pack_quantity]';
        const propertyInputs = Array.from(form.querySelectorAll(`[name="${propertyName}"]`));
        const serverMappingInput = form.querySelector(
            '[name="properties[_fac_use_server_variant_mapping]"]'
        );

        if (serverMappingInput?.value === '1') {
            propertyInputs.forEach((input) => input.remove());

            return null;
        }

        const productForm = form.closest('product-form');

        if (productForm?.dataset.facClientVariantMapping !== 'true') {
            propertyInputs.forEach((input) => input.remove());

            return null;
        }

        let packQuantityMap = {};

        try {
            packQuantityMap = JSON.parse(productForm.dataset.facPackQuantityMap || '{}');
        } catch (error) {
            console.error('[FAC_CART_PRICING] Invalid pack quantity map JSON', error);
        }

        const selectedVariantId = String(form.querySelector('[name="id"]')?.value || '');
        const packQuantity = normalizePackQuantity(packQuantityMap[selectedVariantId]);

        if (packQuantity === null) {
            propertyInputs.forEach((input) => input.remove());

            return null;
        }

        const propertyInput = propertyInputs.shift() || form.ownerDocument.createElement('input');
        propertyInputs.forEach((input) => input.remove());
        propertyInput.type = 'hidden';
        propertyInput.name = propertyName;
        propertyInput.value = packQuantity;

        if (!propertyInput.parentNode) {
            form.appendChild(propertyInput);
        }

        return packQuantity;
    }

    function buildInitialBaseProperties(payload, facPayload, result, useServerVariantMapping) {
        const properties = {
            _printessSaveToken: String(payload['properties[_printessSaveToken]'] || ''),
            _printessThumbnail: String(payload['properties[_printessThumbnail]'] || ''),
            _printessSettings: payload['properties[_printessSettings]'] || '',
            _printessPageCount: String(facPayload.page_count),
            _printessMinPages: String(facPayload.min_pages),
            _printessAdditionalPages: String(facPayload.additional_pages),
            _printessFormFields: payload['properties[_printessFormFields]'] || '[]',
            ...filterProductionProperties(
                formLineItemProperties(payload),
                useServerVariantMapping
            ),
            _fac_is_base: '1',
            _fac_cart_group_id: result.cart_group_id,
            _fac_pricing_signature: result.pricing_signature,
            _fac_pricing_payload: result.pricing_payload,
            _fac_pricing_expires_at: String(result.expires_at),
            _fac_total_delta_cents: String(result.total_delta_cents),
            _fac_printess_template_id: String(result.printess_template_id),
            _fac_printess_template_name: String(
                payload['properties[_fac_printess_template_name]'] || ''
            ),
        };

        if (result.surcharge_variant_id !== null && result.surcharge_variant_id !== undefined) {
            properties._fac_surcharge_variant_id = String(result.surcharge_variant_id);
        }

        return properties;
    }

    function validateSelectedOptions(selectedOptions) {
        if (!selectedOptions || Array.isArray(selectedOptions) || typeof selectedOptions !== 'object') {
            throw new Error('Invalid FAC selected options.');
        }

        for (const [fieldName, value] of Object.entries(selectedOptions)) {
            if (
                typeof fieldName !== 'string' ||
                fieldName.trim() === '' ||
                typeof value !== 'string' ||
                value.trim() === ''
            ) {
                throw new Error('Invalid FAC selected options.');
            }
        }

        return { ...selectedOptions };
    }

    function parseSelectedOptions(rawValue) {
        if (typeof rawValue !== 'string' || rawValue.length === 0) {
            throw new Error('Die Printess Preisdaten konnten nicht gelesen werden. Bitte speichere deine Gestaltung erneut.');
        }

        try {
            return validateSelectedOptions(JSON.parse(rawValue));
        } catch (error) {
            console.error('[FAC_CART_PRICING] Invalid FAC selected options JSON', error);
            throw new Error('Die Printess Preisdaten konnten nicht gelesen werden. Bitte speichere deine Gestaltung erneut.');
        }
    }

    async function validate(requestPayload) {
        const validationResponse = await fetch(CART_VALIDATION_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestPayload),
        });

        if (!validationResponse.ok) {
            throw new Error('Der dynamische Preis konnte nicht validiert werden.');
        }

        const result = await validationResponse.json();

        if (result.dynamic_pricing_enabled !== true) {
            throw new Error('Dynamic pricing is not enabled.');
        }

        if (
            typeof result.pricing_payload !== 'string' ||
            result.pricing_payload.length === 0
        ) {
            throw new Error('Missing pricing authorization payload.');
        }

        return result;
    }

    root.FacCartPricing = {
        validate,
        filterProductionProperties,
        normalizePricingAuthorizationResult,
        validateSelectedOptions,
        syncFlyeralarmVariantProperty,
        syncPackQuantityProperty,

        async beforeCartAdd({ form, formData, config, sections }) {
            const payload = Object.fromEntries(formData.entries());

            const enableConfigurationSurcharges =
                form.closest('product-form')?.dataset.facEnableConfigurationSurcharges === 'true';

            if (!enableConfigurationSurcharges) {
                return null;
            }

            const printessTemplateName = payload['properties[_fac_printess_template_name]'];

            if (!printessTemplateName) {
                return null;
            }

            const selectedOptions = parseSelectedOptions(
                payload[FAC_SELECTED_OPTIONS_FORM_PROPERTY]
            );

            const baseVariantId = String(payload.id || '');
            const baseProductId = String(payload['product-id'] || '');
            const baseQuantity = Number(payload.quantity || 1);
            const saveToken = String(payload['properties[_printessSaveToken]'] || '');
            const useServerVariantMapping = isServerVariantMappingEnabled(
                formLineItemProperties(payload)
            );

            const facPayload = {
                printess_template_name: printessTemplateName,
                shopify_product_id: baseProductId,
                shopify_variant_id: baseVariantId,
                quantity: baseQuantity,
                save_token: saveToken,
                page_count: Number(payload['properties[_printessPageCount]'] || 0),
                min_pages: Number(payload['properties[_printessMinPages]'] || 0),
                additional_pages: Number(payload['properties[_printessAdditionalPages]'] || 0),
                selected_options: selectedOptions,
            };

            const result = normalizePricingAuthorizationResult(
                await validate(facPayload),
                baseQuantity
            );

            const items = [
                {
                    id: baseVariantId,
                    quantity: baseQuantity,
                    properties: buildInitialBaseProperties(
                        payload,
                        facPayload,
                        result,
                        useServerVariantMapping
                    ),
                },
            ];

            if (result.surcharge_quantity > 0) {
                items.push({
                    id: result.surcharge_variant_id,
                    quantity: result.surcharge_quantity,
                    properties: {
                        _fac_is_surcharge: '1',
                        _fac_cart_group_id: result.cart_group_id,
                        _fac_pricing_signature: result.pricing_signature,
                        _fac_pricing_expires_at: String(result.expires_at),
                        _fac_parent_variant_id: baseVariantId,
                        _fac_parent_product_id: baseProductId,
                        _fac_parent_quantity: String(baseQuantity),
                        _fac_parent_save_token_hash_source: 'printess_save_token',
                        _fac_total_delta_cents: String(result.total_delta_cents),
                        _fac_printess_template_id: String(result.printess_template_id),
                        _fac_printess_template_name: String(printessTemplateName),
                    },
                });
            }

            const cartPayload = {
                items,
                sections: sections.map((section) => section.section),
                sections_url: window.location.pathname,
            };

            return {
                body: JSON.stringify(cartPayload),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/javascript',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            };
        },
    };

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = {
            buildInitialBaseProperties,
            filterProductionProperties,
            isServerVariantMappingEnabled,
            normalizePricingAuthorizationResult,
            parseSelectedOptions,
            sanitizeAdditionalProperties,
            syncFlyeralarmVariantProperty,
            syncPackQuantityProperty,
            validateSelectedOptions,
        };
    }
})(typeof window !== 'undefined' ? window : globalThis);
